export function lazyRoute<T extends { default: React.FunctionComponent }>(
  importFn: () => Promise<T>
) {
  return async () => {
    const module = await importFn();

    return { Component: module.default };
  };
}
